export default __webpack_public_path__ + "static/IP_Vision_Pro_03-32abb7c53e237f7c0cc5612aa3bba75e.webp";